import { WPEpic } from '../utils/wp';
import menuEpic from '../components/Header/menu-epic';
import { combineEpics } from 'redux-observable';

export default combineEpics(WPEpic, menuEpic);



// WEBPACK FOOTER //
// ./src/store/root-epic.js